import { Injectable } from '@angular/core';
import { CrmEndpoint, CrmEndpointDecorator } from 'common-module/endpoint';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VersionService {
  @CrmEndpointDecorator({
    configName: 'crm',
    endpointName: 'api',
    endpoint: CrmEndpoint
  })
  endpoint!: CrmEndpoint<any>;

  getApiVersion() {
    return this.endpoint.request('GET', 'version').pipe(
      map((res: { api: string; env: string; name: string }) => {
        return res.api;
      })
    );
  }
}
